export const home = {
    COLUMN_SORT_NAMES: {
        APP_NAME: 'app_name',
        APP_DESCRIPTION: 'app_description',
        CONSTITUENT_TYPE: 'constituent_type',
        SEARCH_TERM: 'search_term',
        PROVIDED_BY: 'provided_by',
        
    }
}


// WEBPACK FOOTER //
// ./src/common/constants/home.js